module.exports = __webpack_public_path__ + "static/media/amlaan.e2082703.png";